import { render, staticRenderFns } from "./ModalCreateConfigImagem.vue?vue&type=template&id=3a87828c&"
import script from "./ModalCreateConfigImagem.vue?vue&type=script&lang=js&"
export * from "./ModalCreateConfigImagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports